import { API } from 'aws-amplify';

import {
  API_DATA_REQUESTED,
  API_ERROR,
  GRID_DATA_RECEIVED,
  OBSTACLES_DATA_RECEIVED,
  GEOFENCE_DATA_RECEIVED,
  UPDATE_INSPECTOR,
  CLOSE_INSPECTOR,
  SELECT_MISSION
} from './actionTypes';

import { requestOptions as options } from '../constants';

export const getOrderData = missionId => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });

  // axios.get(`${mannaApiHost}/order/bymission/get/${missionId}`, options)
  API.get('api', `/order/bymission/get/${missionId}`, options)
    .then(res => {
      dispatch({
        type: UPDATE_INSPECTOR,
        payload: {
          formatter: 'json',
          data: res
        }
      });
    })
    .catch(err => {
      dispatch({
        type: API_ERROR,
        payload: err
      });
    });
};

export const getGridData = coords => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  API.get(
    'api',
    `/airspace/view?latitude=${coords[0]}&longitude=${coords[1]}`,
    options
  )
    .then(res => {
      dispatch({
        type: GRID_DATA_RECEIVED,
        payload: res
        // payload: testData,
      });
    })
    .catch(err => {
      dispatch({
        type: API_ERROR,
        payload: err
      });
    });
};

export const getObstaclesData = coords => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });
  API.get(
    'api',
    `/airspace/obstacles?latitude=${53.276582}&longitude=${-6.27171}`,
    options
  )
    .then(res => {
      // debugger;
      dispatch({
        type: OBSTACLES_DATA_RECEIVED,
        payload: res
      });
    })
    .catch(err =>
      dispatch({
        type: API_ERROR,
        payload: err
      })
    );
};

export const getGeofenceData = () => dispatch => {
  dispatch({ type: API_DATA_REQUESTED });

  // axios.get(`${mannaApiHost}/geofence/list`, options)
  API.get('api', '/geofence/list', options)
    .then(res => {
      dispatch({
        type: GEOFENCE_DATA_RECEIVED,
        payload: res
      });
    })
    .catch(err =>
      dispatch({
        type: API_ERROR,
        payload: err
      })
    );
};

export const selectMission = missionId => ({
  type: SELECT_MISSION,
  payload: missionId
});

export const updateInspector = obj => dispatch => {
  dispatch({
    type: UPDATE_INSPECTOR,
    payload: obj
  });
};

export const closeInspector = () => dispatch => {
  dispatch({
    type: CLOSE_INSPECTOR
  });
};

/* eslint-disable */
export const getGridTestData = coords => dispatch => {
  const testData = {
    'gcjy5:LIVE_DATA:27e97c00-0593-429f-9c06-8ad9eefcea13': [
      '{"latitude":51.7093735,"longitude":-3.0060019,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093731,"longitude":-3.0060016,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093726,"longitude":-3.0060018,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093724,"longitude":-3.0060026,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093727,"longitude":-3.0060034,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093735,"longitude":-3.0060035,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093744,"longitude":-3.006002,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093729,"longitude":-3.0059981,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093676,"longitude":-3.0060042,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093678,"longitude":-3.0060078,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093712,"longitude":-3.0060077,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093697,"longitude":-3.0060069,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093533,"longitude":-3.0060188,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7093227,"longitude":-3.0060438,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7092902,"longitude":-3.0060706,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7092582,"longitude":-3.0060967,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7092253,"longitude":-3.0061232,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7091929,"longitude":-3.006149,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7091601,"longitude":-3.0061757,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7091278,"longitude":-3.0062032,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7090967,"longitude":-3.006231,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7090659,"longitude":-3.0062589,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7090336,"longitude":-3.0062862,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7089997,"longitude":-3.0063112,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7089651,"longitude":-3.0063348,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}',
      '{"latitude":51.7089294,"longitude":-3.0063618,"status":"MISSION","mission_id":"27e97c00-0593-429f-9c06-8ad9eefcea13"}'
    ]
  };

  dispatch({
    type: GRID_DATA_RECEIVED,
    payload: testData
    // payload: testData,
  });
};
